import $ from 'jquery';

export default class Login {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    this.$element = $(element);

    this.$recoverPasswordForm = this.$element.find('#RecoverPasswordForm');
    this.$customerLoginForm = this.$element.find('#CustomerLoginForm');
    this.$recoverPasswordLink = this.$element.find('#RecoverPassword');
    this.$hideRecoverPasswordLink = this.$element.find('#HideRecoverPasswordLink');

    this.$recoverPasswordLink.on('click', (evt) => {
      evt.preventDefault();
      this.showRecoverPasswordForm();
    });

    this.$hideRecoverPasswordLink.on('click', (evt) => {
      evt.preventDefault();
      this.hideRecoverPasswordForm();
      window.localStorage.removeItem('resettingPassword');
    });

    // Allow deep linking to recover password form
    if(window.location.hash === '#recover') {
      this.showRecoverPasswordForm();
    }

    var isResettingPassword = window.localStorage.getItem('resettingPassword');
    if(isResettingPassword) {
      // The password reset email has been sent. Display information.
      $('#ResetSuccess').show();
      window.localStorage.removeItem('resettingPassword');
    }
  }

  showRecoverPasswordForm = () => {
    this.$recoverPasswordForm.show();
    this.$customerLoginForm.hide();

    // Now + 10 minutes (in milliseconds).
    var expiry = new Date(Date.now() + 10 * 60 * 1000);
    localStorage.setItem('resettingPassword', JSON.stringify({
      expiry: expiry.toISOString(),
    }));
  }

  hideRecoverPasswordForm = () => {
    this.$recoverPasswordForm.hide();
    this.$customerLoginForm.show();
  }
}
